import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_ADD_FAVORITES, SET_ADD_FAVORITES, ADD_FAVORITES_REQUEST_FAILED, SENDING_ADD_FAVORITES_REQUEST, GET_USER_FAVORITES,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* addFavorites(action) {
  const { data } = action;

  try {
    yield put({
      type: SENDING_ADD_FAVORITES_REQUEST,
      aFData: '',
      isAFSending: true,
      isAFSuccess: false,
      afError: false,
    });
    const response = yield call(api.favorites.addFavorites, data);
    // console.log(response);
    if (response) {
      yield put({ type: GET_USER_FAVORITES, data });
      yield put({
        type: SET_ADD_FAVORITES,
        aFData: response,
        isAFSending: false,
        afError: false,
        isAFSuccess: true,
      });
    } else {
      yield put({
        type: ADD_FAVORITES_REQUEST_FAILED,
        aFData: null,
        isAFSending: false,
        afError: true,
        isAFSuccess: false,
        fMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: ADD_FAVORITES_REQUEST_FAILED,
      fMsg: e.message,
      isAFSending: false,
      afError: true,
      isAFSuccess: false,
      aFData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchAddFavorites() {
  yield takeLatest(GET_ADD_FAVORITES, addFavorites);
}
